import { render } from "./DocumentClassExportStates.vue?vue&type=template&id=3e789c3f&scoped=true&ts=true"
import script from "./DocumentClassExportStates.vue?vue&type=script&lang=ts"
export * from "./DocumentClassExportStates.vue?vue&type=script&lang=ts"

import "./DocumentClassExportStates.vue?vue&type=style&index=0&id=3e789c3f&scoped=true&lang=css"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e789c3f"]])

export default __exports__